import { I18n } from "@assets/strings";
import React, { useState } from "react";
import styled from "styled-components";
import { useCurrentProfile, useIsPerson } from "@domain/currentProfile/hooks";
import { CourseStatus } from "@domain/lms/course/courseDraft";
import { Person } from "@domain/user/user";
import { useIsMobile } from "@utils/hooks";
import { Content, ContentSelector } from "@ui/components/contentSelector";
import { TagsView } from "@ui/components/inputs/tagsView";
import { Bloc, Row, row } from "@ui/components/layout";
import { CourseStatusFilter } from "./courseStatusFilter";
import { MyArticlesList } from "./myArticlesList";
import { MyCarouselsList } from "./myCarouselsList";
import { MyCoursesList } from "./myCoursesList";
import { MyQuizzesList } from "./myQuizzesList";
import { ProfileArticlesList } from "./profileArticlesList";
import { ProfileCarouselsList } from "./profileCarouselsList";
import { ProfileCoursesList } from "./profileCoursesList";
import { ProfileQuizzesList } from "./profileQuizzesList";

interface ContentListProps extends React.HTMLAttributes<HTMLDivElement> {
	user: Person;
	isTeacher?: boolean;
	organizationName?: string;
	//contentCountList: []
}
const filterTypes: Content[] = ["courses", "articles", "carousels", "quizzes"];
export const ContentList: React.FC<ContentListProps> = ({ user, isTeacher, organizationName }) => {
	const [status, setStatus] = useState<CourseStatus | "ALL">("ALL");
	const currentProfile = useCurrentProfile();
	const isMe = currentProfile?.id === user.id;
	const isPerson = useIsPerson(user);
	const isMobile = useIsMobile();
	const [selectedFilter, setSelectedFilter] = useState(filterTypes[0]);
	//const [selectedFilter, setSelectedFilter] = useState(contentCountList?.filter(((tab) => tab.value !== 0)).map(tab => tab.key)[0]);
	const wording = (content: string): string =>
		I18n.t(isMe ? `profile.content_self.${content}` : `profile.content.${content}`);

	return (
		<>
			{!isMobile ? (
				<Row justify={"space-between"}>
					<Bloc>
						<TagsView
							//tags={contentCountList?.filter(((tab) => tab.value !== 0)).map(tab => tab.key)}
							tags={filterTypes}
							applyWording={(key: string) => wording(key)}
							selectedTag={selectedFilter as string}
							onItemClick={(filter: string) => {
								setSelectedFilter(filter as Content);
							}}
						/>
					</Bloc>
					<Bloc style={{ marginTop: 21 }}>
						{isPerson && <CourseStatusFilter status={status} onStatusChange={(newStatus) => setStatus(newStatus)} />}
					</Bloc>
				</Row>
			) : (
				<Filters>
					<ContentSelector currentContent={selectedFilter} onContentChange={setSelectedFilter} isMe={isMe} />
					{isPerson && <CourseStatusFilter status={status} onStatusChange={(newStatus) => setStatus(newStatus)} />}
				</Filters>
			)}

			{selectedFilter === "courses" &&
				(isMe ? (
					<MyCoursesList status={status} />
				) : (
					<ProfileCoursesList isTeacher={isTeacher} organizationName={organizationName} user={user} />
				))}
			{selectedFilter === "articles" &&
				(isMe ? (
					<MyArticlesList status={status} />
				) : (
					<ProfileArticlesList isTeacher={isTeacher} organizationName={organizationName} user={user} />
				))}
			{selectedFilter === "carousels" &&
				(isMe ? <MyCarouselsList status={status} /> : <ProfileCarouselsList user={user} />)}
			{selectedFilter === "quizzes" &&
				(isMe ? (
					<MyQuizzesList status={status} />
				) : (
					<ProfileQuizzesList isTeacher={isTeacher} organizationName={organizationName} user={user} />
				))}
		</>
	);
};
const Filters = styled.div`
	${row(20, "center", "center")}
	align-self: flex-start;
	margin-bottom: 30px;
	justify-content: space-between;
`;
